import { theme } from '@dasa-health/alma-react'
import styled from 'styled-components'

export const Breadcrumb = styled.div`
    display: flex;
    flex-direction: row;
    margin: 1rem;

    a,
    p {
        padding: 0 0.75rem;
        border-left: 1px solid #c7c7c7;
        text-transform: capitalize;
        font-size: 0.875rem;
        color: #6a6a6a;
        text-decoration: none;

        &:nth-child(1) {
            padding-left: 0;
            border-left: 0;
        }
    }

    @media screen and (max-width: ${theme.breakpoints[0]}) {
        display: none;
    }
`
